import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import MyImage from "../images/MyImage.webp";
import "./AllTypeinsurance.css";
import Logo from "../images/as (9).webp";
import Logo1 from "../images/as (8).webp";
import Logo2 from "../images/as (7).webp";
import Logo3 from "../images/as (6).webp";
import Logo6 from "../images/car insurance.webp";
import Logo7 from "../images/Business-loan.webp";
import Logo8 from "../images/Gadget-loan.webp";
import Logo5 from "../images/Home-loan.webp";

import Footer from "./Footer";
import Navbar from "./Navbar";

import { Link, useLocation } from "react-router-dom";
import Explore from "./Explore";

const cards = [
  { title: "Home Insurance", logo: Logo5, bgColor: "#FFDFDF", link: "/Home" },
  {
    title: "Health Insurance",
    logo: Logo2,
    bgColor: "#DFE2FF",
    link: "/HealthInsurance",
  },
  {
    title: "Life Insurance",
    logo: Logo1,
    bgColor: "#FFDFFC",
    link: "/Lifeinsurance",
  },
  {
    title: "Travel Insurance",
    logo: Logo3,
    bgColor: "#DFF5FF",
    link: "/Travelinsurance",
  },
  {
    title: "Bike Insurance",
    logo: Logo,
    bgColor: "#FFDFDF",
    link: "/Bikeinsurance",
  },
  {
    title: "Car Insurance",
    logo: Logo6,
    bgColor: "#FFFCDF",
    link: "/carinsurance",
  },
  {
    title: "Gadget Insurance",
    logo: Logo8,
    bgColor: "#DFF5FF",
    link: "/Gadget",
  },
  {
    title: "Business Insurance",
    logo: Logo7,
    bgColor: "#DFE2FF",
    link: "/Business",
  },
];

const AllTypeInsurance = () => {
  const location = useLocation(); // ✅ Needed for current page check

  const [activeIndex, setActiveIndex] = useState(0);
  const [isHovering, setIsHovering] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [cycleCount, setCycleCount] = useState(0);
  const intervalRef = useRef(null);
  const leaveTimeout = useRef(null);

  useEffect(() => {
    startAutoplay();
    return () => clearInterval(intervalRef.current);
  }, []);
  
    useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const startAutoplay = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setActiveIndex((prevIndex) => {
        const newIndex = (prevIndex + 1) % cards.length;
        if (newIndex === 0) {
          setCycleCount((prev) => prev + 1);
          setHoveredIndex(null);
          setIsHovering(false);
        }
        return newIndex;
      });
    }, 3000);
  };

  const handleMouseEnter = (index) => {
    if (leaveTimeout.current) {
      clearTimeout(leaveTimeout.current);
    }
    setHoveredIndex(index);
    setActiveIndex(index);
    setIsHovering(true);
    clearInterval(intervalRef.current);
  };

  const handleMouseLeave = () => {
    leaveTimeout.current = setTimeout(() => {
      setHoveredIndex(null);
      setIsHovering(false);
      startAutoplay();
    }, 1000);
  };

  const isCurrentPageCard = (cardLink) => {
    return location.pathname === cardLink;
  };

  return (
    <>
      <Navbar />
      <div className="main-box-box-2">
        <div className="row">
          <div className="col-12 col-md-12">
            <section className="Loan-type-center">
              <div className="container">
                <div className="row justify-content-center align-items-center text-center">
                  <div className="col-12">
                    <div className="main-6">
                      <div className="row align-items-center">
                        <div className="col-12 col-md-6 text-center text-md-start mb-4 mb-md-0 px-md-4">
                          <h1 className="fw-semibold fs-md-2 fs-lg-1 heading_title">
                            Insurance that <br className="d-none d-md-block" />
                            Secures Your Future,
                            <br className="d-none d-md-block" />
                            Hassle-free!
                          </h1>
                        </div>
                        <div className="col-12 col-md-6">
                          <div className="position-relative overflow-hidden d-flex justify-content-center align-items-center">
                            <div className="about-class-box-3 position-absolute"></div>
                            <div
                              className="position-relative"
                              style={{ zIndex: 1 }}
                            >
                              <img
                                src={MyImage}
                                alt="Hero Illustration"
                                className="img-fluid image-class-3"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="Exploreproduct">
              <div className=" container py-5">
                <h2 className="text-center mb-4 fw-semibold">
                  Types of Insurance <br className="d-block d-sm-none" /> We
                  Offer
                </h2>

                <div className="row g-5 justify-content-center">
                  {cards.slice(0, 4).map((card, index) => {
                    const isActive = activeIndex === index;
                    const isHovered = hoveredIndex === index;
                    const isCardActive =
                      isHovered || (isActive && hoveredIndex === null);
                    const currentPageCard = isCurrentPageCard(card.link); // ✅ FIX
                    return (
                      <div
                        key={`row1-${index}`}
                        className="col-12 col-sm-6 col-md-3 col-lg-2 mb-3 mb-sm-3 mb-md-4 mb-lg-4 d-flex flex-column align-items-center px-2 custom-spacing-lg"
                      >
                        <div
                          className={`card-custom  ${
                            isCardActive ? "active-card" : ""
                          }`}
                          style={{
                            backgroundColor: card.bgColor,
                            borderRadius:
                              isCardActive && window.innerWidth > 576
                                ? "50%"
                                : "8px", // No circle on mobile
                            width: window.innerWidth <= 576 ? "240px" : "158px", // 290px only on mobile
                            height:
                              window.innerWidth <= 576 ? "240px" : "158px",
                            transition: "all 0.3s ease-in-out",
                            overflow: isCardActive ? "visible" : "hidden",
                          }}
                          onMouseEnter={() => handleMouseEnter(index)}
                          onMouseLeave={handleMouseLeave}
                        >
                          <div className="card-body-custom d-flex align-items-center justify-content-center w-100 h-100">
                            <Link
                              to={card.link}
                              className="text-decoration-none"
                              style={{
                                outline: "none",
                                border: "none",
                                boxShadow: "none",
                                display: "block",
                                position: "relative",
                                width: "100%",
                                height: "100%",
                              }}
                              onFocus={(e) => e.target.blur()}
                            >
                              <img
                                src={card.logo}
                                alt={card.title}
                                className="logo-img"
                                style={{
                                  width:
                                    window.innerWidth <= 576
                                      ? "200px"
                                      : isCardActive
                                      ? "170px"
                                      : "130px",
                                  height:
                                    window.innerWidth <= 576
                                      ? "200px"
                                      : isCardActive
                                      ? "170px"
                                      : "130px",
                                  transition: "all 0.3s ease-in-out",
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  zIndex: isCardActive ? 3 : 2,
                                  pointerEvents: "none",
                                  outline: "none",
                                  border: "none",
                                  boxShadow: "none",
                                  opacity: isCurrentPageCard ? 0.9 : 1,
                                  filter: isCurrentPageCard
                                    ? "brightness(1.1) saturate(1.2)"
                                    : "none",
                                }}
                                draggable={false}
                                onFocus={(e) => e.target.blur()}
                              />
                            </Link>
                          </div>
                        </div>
                        <div className="w-100 text-center position-abs py-2">
                          <Link
                            to={card.link}
                            className="text-decoration-none text-dark"
                            style={{
                              color: currentPageCard ? "#007bff" : "#000",
                              fontWeight: currentPageCard ? "600" : "normal",
                            }}
                          >
                            <h6
                              className="mb-0"
                              style={{
                                fontFamily: "poppins",
                                fontSize: "20px",
                              }}
                            >
                              {card.title}
                            </h6>
                          </Link>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="row g-5 justify-content-center">
                  {cards.slice(4, 8).map((card, index) => {
                    const actualIndex = index + 4;
                    const isActive = activeIndex === actualIndex;
                    const isHovered = hoveredIndex === actualIndex;
                    const isCardActive =
                      isHovered || (isActive && hoveredIndex === null);
                    const currentPageCard = isCurrentPageCard(card.link); // ✅ FIX
                    return (
                      <div
                        key={`row2-${index}`}
                        className="col-12 col-sm-6 col-md-3 col-lg-2 mb-3 mb-sm-3 mb-md-4 mb-lg-4 d-flex flex-column align-items-center px-2 custom-spacing-lg"
                      >
                        <div
                          className={`card-custom ${
                            isCardActive ? "active-card" : ""
                          }`}
                          style={{
                            backgroundColor: card.bgColor,
                            borderRadius:
                              isCardActive && window.innerWidth > 576
                                ? "50%"
                                : "8px", // No circle on mobile
                            width: window.innerWidth <= 576 ? "240px" : "158px", // 290px only on mobile
                            height:
                              window.innerWidth <= 576 ? "240px" : "158px",
                            transition: "all 0.3s ease-in-out",
                            overflow: isCardActive ? "visible" : "hidden",
                          }}
                          onMouseEnter={() => handleMouseEnter(actualIndex)}
                          onMouseLeave={handleMouseLeave}
                        >
                          <div className="card-body-custom d-flex align-items-center justify-content-center w-100 h-100">
                            <Link
                              to={card.link}
                              className="text-decoration-none"
                              style={{
                                outline: "none",
                                border: "none",
                                boxShadow: "none",
                                display: "block",
                                position: "relative",
                                width: "100%",
                                height: "100%",
                              }}
                              onFocus={(e) => e.target.blur()}
                            >
                              <img
                                src={card.logo}
                                alt={card.title}
                                className="logo-img"
                                style={{
                                  width: isCardActive ? "170px" : "130px",
                                  height: isCardActive ? "170px" : "130px",
                                  transition: "all 0.3s ease-in-out",
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  zIndex: isCardActive ? 3 : 2,
                                  pointerEvents: "none",
                                  outline: "none",
                                  border: "none",
                                  boxShadow: "none",
                                  opacity: isCurrentPageCard ? 0.9 : 1,
                                  filter: isCurrentPageCard
                                    ? "brightness(1.1) saturate(1.2)"
                                    : "none",
                                }}
                                draggable={false}
                                onFocus={(e) => e.target.blur()}
                              />

                              <img
                                src={card.logo}
                                alt={card.title}
                                className="logo-img"
                                style={{
                                  width:
                                    window.innerWidth <= 576
                                      ? "200px"
                                      : isCardActive
                                      ? "170px"
                                      : "130px",
                                  height:
                                    window.innerWidth <= 576
                                      ? "200px"
                                      : isCardActive
                                      ? "170px"
                                      : "130px",
                                  transition: "all 0.3s ease-in-out",
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  zIndex: isCardActive ? 3 : 2,
                                  pointerEvents: "none",
                                  outline: "none",
                                  border: "none",
                                  boxShadow: "none",
                                  opacity: isCurrentPageCard ? 0.9 : 1,
                                  filter: isCurrentPageCard
                                    ? "brightness(1.1) saturate(1.2)"
                                    : "none",
                                }}
                                draggable={false}
                                onFocus={(e) => e.target.blur()}
                              />
                            </Link>
                          </div>
                        </div>
                        <div className="w-100 text-center position-abs py-2">
                          <Link
                            to={card.link}
                            className="text-decoration-none text-dark"
                            style={{
                              color: currentPageCard ? "#007bff" : "#000",
                              fontWeight: currentPageCard ? "600" : "normal",
                            }}
                          >
                            <h6
                              className="mb-0"
                              style={{
                                fontFamily: "poppins",
                                fontSize: "20px",
                              }}
                            >
                              {card.title}
                            </h6>
                          </Link>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <Explore />
      <Footer />
    </>
  );
};

export default AllTypeInsurance;
